<template>
    <div class="footer footer-static">
      <div>
        <div class="footer-col" v-html="$root.t('startpage:footer:column_1')">
        </div>
        <div class="footer-col">
          <span v-html="$root.t('startpage:footer:column_3')"></span>
          <template v-for="p in $root.pages">
            <router-link class="decorated" style="display: inline-block;" :key="p.Contribution.Id" v-html="p.Data.Link.Content&&p.Data.Link.Content[$root.language]?p.Data.Link.Content[$root.language]:p.Contribution.Name" :to="{name: 'page', params: {id: p.Contribution.Id, name: p.Contribution.Name}}"></router-link>
            <br/>
          </template>
          <!--<a class="decorated" href="#" v-on:click.prevent="$root.toggleDebug()">Debug Mode</a>-->
        </div>
        <div class="footer-col" v-html="$root.t('startpage:footer:column_2')">
        </div>
        <div class="footer-col" v-html="$root.t('startpage:footer:column_4')">
        </div>                  
      </div>
    </div>
</template>


<script>

export default {
  name: 'StaticFooter'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
